export default "__VITE_ASSET__Dz5em$u3__"